import { compact } from "lodash";
import toggleHelper from "./togglehelper";
import MenuToggle from './menutoggle';

export default class Navigation {
  constructor(element) {
    this.searchButtonClass = element.getAttribute("data-toggle-search");
    this.searchFormClass = element.getAttribute("data-search-form");
    this.closeSearchFormClass = element.getAttribute("data-close-search");

    this.searchButtons = Array.from(
      document.getElementsByClassName(this.searchButtonClass),
    );
    this.searchForm = document.getElementsByClassName(this.searchFormClass)[0];
    this.closeSearchFormButton = document.getElementsByClassName(
      this.closeSearchFormClass,
    )[0];

    this.helper = new toggleHelper();

    this.searchButtons.map((item) =>
      item.addEventListener("click", (e) => {
        this.toggleSearchForm(this.searchButtons, e.target);
        onCloseMenu();
        const form = this.searchForm;
        setTimeout(function() {
          const input = form.querySelector(".awesomplete input") || form.querySelector("input[type=search]");
          if (input) input.focus();
        }, 0);
      }),
    );

    this.closeSearchFormButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleSearchForm(this.searchButtons);
      this.selectedSearchButton.focus();
    });

    // MENU TOGGLE 2025
    const toggleButton = document.querySelector(".header__primary-menu-button");
    const menuContainer = document.querySelector(".main-navigation");
    const helper = new toggleHelper();
    toggleButton.addEventListener("click", () => {
      // Fetch scrollbar width, used as padding when scrollbar is hidden
      document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
      helper.toggleAttr(toggleButton, [toggleButton]);

      const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        // Use your container as the root from which to query
        const activeItem = menuContainer.querySelector(".main-navigation__item--active");
        if (activeItem) {
          // Smooth scrolling to the active item
          // activeItem.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" });
          // Fast!
          activeItem.scrollIntoView({ block: "center", inline: "nearest" });
        }
      }

      menuContainer.setAttribute("aria-hidden", String(!isExpanded));
      menuContainer.classList.toggle("is-visible", isExpanded);

      document.addEventListener("keydown", onMenuKeydown);
    });

    const backdrop = document.querySelector(".main-navigation-backdrop");
    const filler = document.querySelector(".main-navigation-filler");
    const closeButton = document.querySelector(".main-navigation-button__close");
    const onMenuKeydown = (event) => {
      if (event.key === "Escape" && menuContainer.classList.contains("is-visible")) {
        onCloseMenu();
      }
    };
    const onCloseMenu = () => {
      menuContainer.classList.add('is-closing');
      setTimeout(function() {
        menuContainer.classList.remove("is-visible");
        menuContainer.classList.remove("is-closing");
      }, 400);

      menuContainer.setAttribute("aria-hidden", "true");
      backdrop.setAttribute("aria-hidden", "true");

      toggleButton.setAttribute("aria-expanded", "false");
      toggleButton.focus();

      document.removeEventListener("keydown", onMenuKeydown);
    };
    [closeButton, backdrop, filler].forEach((element) => {
      element.addEventListener("click", onCloseMenu);
    });

    const allToggleButtons = document.querySelectorAll('.main-navigation__list-item-icon');

    allToggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        const isRootLevel = button.classList.contains('main-navigation__root-toggle');

        if (isRootLevel) {
          document.querySelectorAll('.main-navigation__root-toggle[aria-expanded="true"]')
            .forEach(otherBtn => {
              if (otherBtn !== button) {
                otherBtn.setAttribute('aria-expanded', 'false');

                const otherMenuId = otherBtn.getAttribute('aria-controls');
                const otherMenuEl = document.getElementById(otherMenuId);
                if (otherMenuEl) {
                  otherMenuEl.setAttribute('aria-expanded', 'false');

                  const subToggles = otherMenuEl.querySelectorAll(
                    '.main-navigation__list-item-icon:not(.main-navigation__root-toggle)'
                  );
                  subToggles.forEach(subToggle => {
                    subToggle.setAttribute('aria-expanded', 'false');
                    const subMenuId = subToggle.getAttribute('aria-controls');
                    const subMenuEl = document.getElementById(subMenuId);
                    if (subMenuEl) {
                      subMenuEl.setAttribute('aria-expanded', 'false');
                    }
                  });
                }
              }
            });
        }

        const wasExpanded = button.getAttribute('aria-expanded') === 'true';
        const newState = !wasExpanded;
        button.setAttribute('aria-expanded', String(newState));

        const controlledMenuId = button.getAttribute('aria-controls');
        const controlledMenu = document.getElementById(controlledMenuId);
        if (controlledMenu) {
          controlledMenu.setAttribute('aria-expanded', String(newState));
          const level = button.dataset.level;
          const activeClass = `main-navigation__link-wrapper--active-${level}`;

          const linkWrapper = button.closest('.main-navigation__link-wrapper');
          const rootLinkWrapper = button.closest('.main-navigation__menu-item-link');
          const targetWrapper = linkWrapper || rootLinkWrapper;
          if (targetWrapper) {
            if (newState) {
              targetWrapper.classList.add(activeClass);
            } else {
              targetWrapper.classList.remove(activeClass);
            }
          }
          if (isRootLevel && newState === false) {
            const subToggles = controlledMenu.querySelectorAll(
              '.main-navigation__list-item-icon:not(.main-navigation__root-toggle)'
            );
            subToggles.forEach(subToggle => {
              subToggle.setAttribute('aria-expanded', 'false');
              const subMenuId = subToggle.getAttribute('aria-controls');
              const subMenuEl = document.getElementById(subMenuId);
              if (subMenuEl) {
                subMenuEl.setAttribute('aria-expanded', 'false');
              }
            });
          }
          if (isRootLevel && newState) {
            document.querySelectorAll(
              '.main-navigation__link-wrapper[class*="main-navigation__link-wrapper--active-"], .main-navigation__menu-item-link[class*="main-navigation__link-wrapper--active-"]'
            ).forEach(wrapper => {
              if (wrapper !== targetWrapper) {
                wrapper.className = wrapper.className.replace(/main-navigation__link-wrapper--active-\S+/g, '');
              }
            });
          }
        }
      });
    });

    this.now = new Date();
    this.loginBumps = Array.from(
      document.getElementsByClassName("header__login-bump"),
    );
    this.loginBumpStorageKey = "login-bump";
    this.animationTimeout;
    this.loginBumpStorageValue = JSON.parse(
      localStorage.getItem(this.loginBumpStorageKey),
    );

    this.globalDisplayTime = 60 * 50
    this.loginButtons = Array.from(
      document.getElementsByClassName("header__login-button"),
    );

    this.asyncLoginBumpReveal();
  }

  toggleSearchForm(items) {
    this.updateSelectedSearchButton();

    items.map((item) => {
      this.helper.toggleAttr(item, [item, this.searchForm]);
    });
  }

  updateSelectedSearchButton() {
    this.selectedSearchButton =
      document.body.offsetWidth > 1040
        ? this.searchButtons[0]
        : this.searchButtons[1];
  }

  asyncLoginBumpReveal = async () => {
    if (!this.loginBumps) return;

    this.loginButtons.map((button) => {
      button.addEventListener("click", (e) => {
        this.setBumpStorage(this.now.getTime());
      });
    });

    if (
      this.loginBumpStorageValue &&
      this.now.getTime() < this.loginBumpStorageValue.expiryTime
    ) {
      if (this.now.getTime() > this.loginBumpStorageValue.displayTime) {
        this.hideBumps();
      } else {
        this.showBumps();

        const remainingDisplayTime =
          this.loginBumpStorageValue.displayTime - this.now.getTime();
        setTimeout(() => {
          this.hideBumps();
        }, remainingDisplayTime);
      }
      return;
    }

    this.showBumps();

    const success = await this.setBumps();

    if (success) {
     setTimeout(() => {
        this.hideBumps();
      }, this.globalDisplayTime);
    }
  };

  setBumps() {
    return new Promise((resolve) => {
      this.setBumpStorage(this.now.getTime() + this.globalDisplayTime);

      resolve(true);
    });
  }

  hideBumps() {
    clearTimeout(this.animationTimeout);

    this.loginBumps.map((bump) => {
      bump.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 1000,
      });

      this.animationTimeout = setTimeout(() => {
        bump.classList.add("u-display-none");
      }, 1000);
    });
  }

  showBumps() {
    clearTimeout(this.animationTimeout);

    this.loginBumps.map((bump) => {
      this.animationTimeout = setTimeout(() => {
        bump.classList.remove("u-display-none");
      }, 0);

      bump.animate(
        [
          { transform: "scale(0.8)" },
          { transform: "scale(0.9)" },
          { transform: "scale(0.98)" },
          { transform: "scale(0.9)" },
          { transform: "scale(1)" },
        ],
        {
          duration: 600,
        },
      );
    });
  }

  setBumpStorage(displayTime) {
    localStorage.setItem(
      this.loginBumpStorageKey,
      JSON.stringify({
        expiryTime: this.now.getTime() + 2 * (24 * (60 * 60 * 1000)), // 2 days
        displayTime: displayTime,
      }),
    );
  }
}
